import { render } from "./AddConfirmModal.vue?vue&type=template&id=b1f30df8"
import script from "./AddConfirmModal.vue?vue&type=script&lang=js"
export * from "./AddConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__